import { NEUTRAL_200, NEUTRAL_100 } from 'visitor-ui-component-library/constants/WidgetColors';
const defaultFileAttachmentTheme = {
  tileBackgroundColor: NEUTRAL_100,
  tileBorderColor: NEUTRAL_200
};
const FileAttachmentTheme = themeProps => Object.assign({}, defaultFileAttachmentTheme, themeProps);
export default FileAttachmentTheme;